<template>
  <div v-if="documents.length === 0" class="empty-text">{{ $I18N("该目录下暂无文档") }}</div>
  <div v-else class="document-grid">
    <div
      v-for="(doc, index) in documents"
      :key="index"
      :href="doc.url"
      class="document-card"
      :download="doc.name"
	  @click="onDownload(doc.name)"
    >
      <div class="document-icon">📄</div>
      <div class="document-name">{{ doc.name }}</div>
      <div class="document-size">{{ formatFileSize(doc.length) }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  documents: {
    type: Array,
    required: true
  }
})

function formatFileSize(bytes) {
  if (!bytes) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB']
  let i = 0
  let size = bytes
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024
    i++
  }
  return size.toFixed(1) + ' ' + units[i]
}
const emit = defineEmits(['download'])
function onDownload(name) {
  emit('download', name)
}
</script>
<style>
	/* 文档网格布局 */
	.document-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
		gap: 16px;
		padding: 10px 0;
		overflow-y: auto;
	}
	
	.document-card {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px;
		border: 1px solid #e8e8e8;
		border-radius: 8px;
		text-decoration: none;
		color: #333;
		transition: all 0.3s ease;
		cursor: pointer;
	}
	
	.document-card:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		transform: translateY(-4px);
		border-color: #1890ff;
	}
	
	.document-icon {
		font-size: 48px;
		margin-bottom: 12px;
	}
	
	.document-name {
		font-size: 14px;
		text-align: center;
		word-break: break-word;
		margin-bottom: 8px;
	}
	
	.document-size {
		font-size: 12px;
		color: #999;
	}
	
</style>